import script from "./Policies.vue?vue&type=script&setup=true&lang=js"
export * from "./Policies.vue?vue&type=script&setup=true&lang=js"

import "./Policies.vue?vue&type=style&index=0&id=a9b21d12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b21d12"]])

export default __exports__